module.exports = __webpack_public_path__ + "static/media/arrow_down_icon.2b3dad9f.png";